import { action } from 'satcheljs';

/**
 * Action to set a category name in categoryNames.
 */
const setMeetingTypeCategory = action(
    'SET_PBP_CATEGORY_NAME',
    (categoryNames: string[] | undefined) => ({
        categoryNames,
    })
);

export default setMeetingTypeCategory;
